import { render, staticRenderFns } from "./ShelfLoading.vue?vue&type=template&id=4cd9ea24&"
import script from "./ShelfLoading.vue?vue&type=script&lang=js&"
export * from "./ShelfLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports